module.exports = {"data":{"markdownRemark":{"html":"<h3>Name, Email, Message</h3>","frontmatter":{"title":"Contact"}}},"pathContext":{"id":"/opt/build/repo/src/pages/contact/index.md absPath of file >>> MarkdownRemark"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/contact.json
// module id = 481
// module chunks = 184662623972074